import {giveTextColorForBackGroundColor} from "@/util/ColorUtil";

class PlannedShift {

    constructor(startDate, endDate, shiftId, color, name, adjusted) {
        this.start = startDate;
        this.allDay = true;
        this.end = endDate;
        this.color = color;
        this.textColor = giveTextColorForBackGroundColor(color);
        this.title = name;
        this.adjusted = adjusted;
        this.extendedProps = {shiftId: shiftId};
    }
}

export default PlannedShift;